<div class="icd-search-container">
    <input type="text"  class="search form-control" [(ngModel)]="currentData.filterKey" [attr.placeholder]="'field.hint.search' | translate | async"  (keydown.enter)="handleKeyEnter($event)">
      <i class="fa fa-search icd-icons icd-search-icon" (click)="handleKeyEnter('')" aria-hidden="true"></i>
      <i class="fa fa-sort icd-icons icd-toggle-icon" (click)="toggleSearchBox()" aria-hidden="true"></i>
  </div>
  <div *ngIf="currentData.searchData && currentData.show">
    <ng-container *ngFor="let cd of currentData.searchData">
      <div class="_icd-search-items" [ngClass]="{'selected' : cd.selected}">
        <i *ngIf="!cd.isLeaf || cd.theCode == ''"class="fa fa-caret-right" (click)="getChild(cd)"></i><span *ngIf="cd.theCode != ''">&nbsp;&nbsp;{{cd.theCode}}&nbsp;&nbsp;</span>
        <div [innerHtml]="cd.title"(click)="selectChild(cd)" class="parent parent_{{cd.ID}}"></div>
      </div>
        <ng-container *ngIf="cd.child_data">
          <ng-container
              *ngTemplateOutlet="Recursion; context:{ list: cd.child_data}"
          ></ng-container>
      </ng-container>
    </ng-container>
  </div>
  <div class="icd-list-container" *ngIf="currentData.show_sections">
    <ng-container *ngIf="currentData.rootData">
        <div *ngFor="let cd of currentData.rootData">
            <div class="_icd-search-items">
              <i class="fa fa-caret-right" aria-hidden="true" (click)="getChild(cd)"></i>
              <div (click)="selectChild(cd)" class="parent parent_{{cd.ID}}">{{cd.code}}&nbsp;&nbsp;{{cd.name_}}</div>
            </div>
                <ng-container *ngIf="cd.child_data">
                    <ng-container
                        *ngTemplateOutlet="Recursion; context:{ list: cd.child_data}"
                    ></ng-container>
                </ng-container>
        </div>
    </ng-container>
  </div>
  <div class="popup-floating-bar" *ngIf="currentData.selectedData && currentData.selectedData.length > 0">
    <div class="popup-floating-button">
      <button type="button" (click)="submitBtn()" style="text-align: center;" class="primary-btn"><span>{{'button.submit' | translate | async}}</span>
          <i class="fa fa-plus-square" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  
  
  <ng-template #Recursion let-list="list">
      <ng-container *ngFor="let item of list">
        <div [hidden]="item.selectedNode != undefined && item.selectedNode == false" class="_icd-search-items" [ngStyle]="{'padding-left': item.padding+'px'}">
          <i *ngIf="item.classKind != 'category' || item.child != undefined" class="fa fa-caret-right" aria-hidden="true" (click)="getChild(item)"></i>
          <div [ngClass]="{'selected' : item.selected, 'last_child_' : item.isLeaf ,'selected_node': 'item.selectedNode'}" (click)="selectChild(item)" class="child-parent parent_{{item.parentId}}">{{item.code}}&nbsp;&nbsp;{{item.name_}}</div>
        </div>
        <ng-container *ngIf="item.child_data && item.child_data.length > 0">
          <ng-container
            *ngTemplateOutlet="Recursion; context:{ list: item.child_data }"
          ></ng-container>
        </ng-container>
      </ng-container>
    </ng-template> 
